<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { CheckCircle2, CircleAlert, Info } from 'lucide-vue-next'
import { useAppStore } from '@/stores/app'
const { toasts } = storeToRefs(useAppStore())
</script>

<template>
  <div class="toast-stack" aria-live="polite">
    <TransitionGroup name="toast">
      <div v-for="toast in toasts" :key="toast.id" class="toast" :class="toast.tone">
        <CheckCircle2 v-if="toast.tone === 'success'" :size="18" />
        <CircleAlert v-else-if="toast.tone === 'error'" :size="18" />
        <Info v-else :size="18" />
        <span>{{ toast.text }}</span>
      </div>
    </TransitionGroup>
  </div>
</template>
